"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var MzTextareaPrefixDirective = (function () {
    function MzTextareaPrefixDirective(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
    }
    MzTextareaPrefixDirective.prototype.ngOnInit = function () {
        this.renderer.setElementClass(this.elementRef.nativeElement, 'prefix', true);
    };
    return MzTextareaPrefixDirective;
}());
MzTextareaPrefixDirective.decorators = [
    { type: core_1.Directive, args: [{
                selector: 'i[mzTextareaPrefix], i[mz-textarea-prefix]',
            },] },
];
/** @nocollapse */
MzTextareaPrefixDirective.ctorParameters = function () { return [
    { type: core_1.ElementRef, },
    { type: core_1.Renderer, },
]; };
exports.MzTextareaPrefixDirective = MzTextareaPrefixDirective;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-materialize/dist/textarea/textarea-prefix/textarea-prefix.directive.js
// module id = ./node_modules/ng2-materialize/dist/textarea/textarea-prefix/textarea-prefix.directive.js
// module chunks = vendor